import { urlMainAPI, defaultSuccess, emitEventBuss } from "@/global";
import { SingletonEnginnering } from "../nodes/_service/singletonEngineering";

import axios from "axios";
import Validators from "../nodes/_service/singletonTools/validators";

const CancelToken = axios.CancelToken;
let executeRequest = CancelToken.source();
const refreshToken = () => {
  executeRequest = CancelToken.source();
};

export var PapMixin = {

  data() {
    return {
      xml: null,
      objectStructure: {},
      tableFlowChart: [],
      papSent: false,
      tableLossForm: [],
      formLossSent: false,
      onSimulation: null,
      stopTrySimulation: false,
      taskSimulation: 0,
      callReloadNodes: 0,
      result: {},
      totalExecutionAttemptErrors: 0,
    };
  },

  watch: {

  },

  methods: {
    play() {
      emitEventBuss("ExecuteSimulation", null);
    },

    async executeSimulation() {
      /**
       * Adiciona mensagem de vento se tiver mais de 3 tentativas de execução com error
       */
      function addEventMessage() {
        this.totalExecutionAttemptErrors = this.totalExecutionAttemptErrors + 1;
        if(this.totalExecutionAttemptErrors >= 3) {
          const systemEventMessage = {
            "type": "Error",
            "title": "Falha Detectada",
            "subtitle": "Simulação não executada.",
            "origin": 'PAP',
            "categories": ['PAP'],
            "date": new Date(),
            "bag": {
              "Descrição": "O cenário selecionado apresenta erros que impedem a simulação de prosseguir.",
              "Efeito": "Falha na simulação do cenário selecionado.",
              "Recomendação": "Tente realizar a simulação com o cenário Padrão, caso persistir o erro entre em contato com o suporte Pentagro."
            }
          }
          const TYTE_ERROR = 3
          axios.post(`${urlMainAPI}/addsystemeventmessage`, {...systemEventMessage, "type": TYTE_ERROR}).then((res) => {
            this.totalExecutionAttemptErrors = 0;
            this.$store.commit('addSystemMessage', systemEventMessage)
          }).catch(() => {
            this.totalExecutionAttemptErrors = 0;
            this.$store.commit('addSystemMessage', systemEventMessage)
          })
        }
      }

      defaultSuccess(this.$t('iniciando-simulacao'));

      let xml = await JSON.parse(localStorage.xml)
      if (!xml)
        throw "XML não carregado!"

      let obj = {
        scenario: xml.scenario,
        tableFlowChart: [...this.tableFlowChart, ...this.tableLossForm]
      };
      Validators.readOnly = this.readOnly

      obj.tableFlowChart = Validators.CheckProblemsInEnginneringMapping(obj.tableFlowChart)
      console.log('Enviado para simulação :>> ', obj.tableFlowChart);
      const url = `${urlMainAPI}/executesimulationbypap`;

      const maxRetries = 3;
      let result = null;
      let lastError = null;

      this.$bvModal.show("resultSimulation");
      this.stateOfSimulation(true);
      const startCountTime = Date.now();

      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          result = await axios.post(url, obj, { cancelToken: executeRequest.token });

          // Verifica "pipe is broken" na resposta (falha intermitente do simulador)
          const errorText = (result.data && result.data.error) ? result.data.error : '';
          const isPipeBroken = errorText.toLowerCase().includes('pipe') || errorText.toLowerCase().includes('broken');

          if (isPipeBroken && attempt < maxRetries) {
            console.warn(`[Simulação] Pipe broken na tentativa ${attempt}/${maxRetries}, retentando...`);
            this.$bvToast.toast(`Tentativa ${attempt}/${maxRetries} falhou (pipe). Retentando...`, {
              title: 'Simulação',
              variant: 'warning',
              toaster: 'b-toaster-bottom-left',
              solid: true,
              autoHideDelay: 2000
            });
            await new Promise(resolve => setTimeout(resolve, 1000));
            continue;
          }

          lastError = null;
          break;
        } catch (e) {
          // Cancelamento manual — não retenta
          if (axios.isCancel(e)) {
            lastError = e;
            break;
          }

          lastError = e;
          const detail = e.response?.data?.detail || e.response?.data?.error || e.message || '';
          const isPipeBroken = detail.toLowerCase().includes('pipe') || detail.toLowerCase().includes('broken');

          if (isPipeBroken && attempt < maxRetries) {
            console.warn(`[Simulação] Pipe broken (exceção) na tentativa ${attempt}/${maxRetries}, retentando...`);
            this.$bvToast.toast(`Tentativa ${attempt}/${maxRetries} falhou (pipe). Retentando...`, {
              title: 'Simulação',
              variant: 'warning',
              toaster: 'b-toaster-bottom-left',
              solid: true,
              autoHideDelay: 2000
            });
            await new Promise(resolve => setTimeout(resolve, 1000));
            continue;
          }

          break;
        }
      }

      if (lastError) {
        this.$bvModal.hide("resultSimulation");
        addEventMessage.call(this);
      } else if (result) {
        const endCountTime = Date.now();
        this.result = result.data;
        this.result.simulationTimeFront = (endCountTime - startCountTime) / 1000;
        defaultSuccess(result.data);
      }

      this.stateOfSimulation(false);
    },

    stopSimulation() {
      executeRequest.cancel("Cancelamento executado com sucesso!");
      refreshToken();
      this.stopTrySimulation = true;
      const url = `${urlMainAPI}/stopsimulation`;
      axios.get(url).then(defaultSuccess(this.$t('simulacao-cancelada'))).catch();
      refreshToken();
    },

    async calculate(obj, callbackLoading) {
      defaultSuccess(this.$t('realizando-calculos'));
      if (!obj) {
        obj = {
          scenario: null,
          scenarioResult: null,
        };

        obj.scenario = this.result.scenario;
        obj.scenarioResult = this.result.scenarioResult;
      }

      callbackLoading(true);
      const url = `${urlMainAPI}/getmodelobjectstructure`;
      await axios
        .post(url, obj)
        .then((res) => {
          this.objectStructure = res.data;
          defaultSuccess(this.$t('atualizando-valores'));
          this.objectStructure.callReload = ++this.callReloadNodes;
          this.objectStructure.forceReloadInputs = !!obj?.forceReloadInputs;

          let xml = {
            scenario: obj.scenario ?? this.result?.scenario,
            scenarioResult: obj.scenarioResult ?? this.result?.scenarioResult,
            scenarioObjectStructure: res.data
          }

          this.$store.commit("setXML", xml);
          localStorage.setItem("xml", JSON.stringify(xml));
        })
        .catch(function (e) {
          console.log(e);
          callbackLoading(false);
        });

      this.simulationResult = {
        table: this.tableInput,
        tableResult: this.tableOutput,
      };
    },

    stateOfSimulation(isSimulating) {
      if (isSimulating === "state") {
        return this.onSimulation;
      }
      this.onSimulation = isSimulating;
      return this.onSimulation;
    },

    async loadAreas() {
      let areas = [{ area: "PAP", configuration: [] }];
      const url = `${urlMainAPI}/getflowcharts`;
      await axios
        .get(url)
        .then((res) => {
          areas = res.data;
        })
        .catch();

      return areas
    },

    async loadmodelObjectStructure() {
      defaultSuccess(this.$t('carregando-configuracoes-do-pap'))
      if (!SingletonEnginnering.isLoaded) {
        let xml = localStorage.xml ? await JSON.parse(localStorage.xml) : "";

        if (xml && xml.scenarioObjectStructure) {
          SingletonEnginnering.load(xml.scenarioObjectStructure);
          defaultSuccess(this.$t('configuracoes-do-pap-carregadas'))
        } else {
          let url = `${urlMainAPI}/loadactivesimulationscenario`

          axios
            .get(url)
            .then((res) => {
              let xml = {};
              xml.name = res.data.name;
              xml.scenario = res.data.scenario;
              xml.scenarioResult = res.data.scenarioResult;
              xml.scenarioObjectStructure = res.data.scenarioObjectStructure;

              SingletonEnginnering.load(xml.scenarioObjectStructure);

              this.$store.commit("setXML", xml);
              localStorage.setItem("xml", JSON.stringify(xml));

              defaultSuccess(this.$t('configuracoes-carregadas'))
            })
            .catch((e) => {
              console.log("Falha no recebimento da requisição getmodelobjectstructure :>> ", e)
            }
            );
        }
      }
    },
  },

  async mounted() { },

  destroyed() {
  },
};
